export const RUSSIA_RATE_FIELD_SETTINGS = {
  min: 0,
  max: 0.8,
};

export const KAZAKHSTAN_RATE_FIELD_SETTINGS = {
  min: 0.01,
  max: 0.99,
};
